const ToolboxInfo = {
  maxInstances: {
    controls_repeat_var_internal: 1,
    character_motion_move: 1,
    variables_set: 1,
    variables_get: 1,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "controls_repeat_var_internal",
          },
          {
            kind: "block",
            type: "character_motion_move",
          },
          {
            kind: "block",
            type: "variables_set",
            fields: {
              VAR: { name: "へんすう" },
            },
            inputs: {
              VALUE: {
                shadow: {
                  type: "math_number",
                  fields: {
                    NUM: 0,
                  },
                },
              },
            },
          },
          {
            kind: "block",
            type: "variables_get",
            fields: {
              VAR: { name: "へんすう" },
            },
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
